import * as React from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { Routine } from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";
import { connect } from "react-redux";

import { updateAutoTracking, updatePowerSaving } from "../../Store/routines";
import InformationIcon from "../../../../Elements/Icon/Icons/InformationIcon";
import { LabelWrapper, RowLabel, ToggleWrap, RowWrapper, PaddedCol } from "../TrackingOptions";
import {Info, LoaderWrap} from "..";
import withFormWrapper from "@Elements/Form/formWrapper";
import {SettingDTO, TrackingSettings} from "../../types";
import Tooltip from "@Elements/Tooltip";
import Loader from "@Elements/Loader";
import Toggle from "@Elements/Switch/Toggle";
import { AppState } from "@Safemate/Store/types";
import {Geofence} from "@Safemate/Settings/Geofence/types";



interface AutoToggleProps extends WrappedComponentProps {
  updateAutoTracking: Routine<ActionFunctionAny<Action<any>>>;
  updatePowerSaving: Routine<ActionFunctionAny<Action<any>>>;
  autoTracking: boolean;
  processingAutoTracking: boolean;
  disablePositioning: boolean;
  deviId: number;
  geofence: Geofence[];
}

const AutoToggle = injectIntl(withFormWrapper<Record<string, SettingDTO>, AutoToggleProps>(({ intl: {formatMessage}, updateAutoTracking, autoTracking, updatePowerSaving, disablePositioning, processingAutoTracking, deviId, geofence, formik:{setFieldValue, values} }) => {

  const hasGeofence = ( geofence && geofence.length > 0 && geofence.some( item => item.enabled === true));

  return(
    <RowWrapper>
      <LabelWrapper xs={12} sm={5} md={5}>
        <RowLabel>      
          {formatMessage({id: "automaticTracking", defaultMessage: "Automatisk lokalisering"})}
        </RowLabel>
        <Tooltip
          popoverId="auto-tracking-popover"
          labelId="autoTrackingDesc"
          defaultMessage="Enheten vil forsøke å lokalisere iht. angitt lokaliseringsintervall mens Safematen er i bevegelse. Når Safematen er i ro, vil den spare batterikapasitet ved å skru av lokaliseringen."
        >
          <InformationIcon size="medium" />
        </Tooltip> 
      </LabelWrapper>
      <PaddedCol sm={7} md={7}>
      {disablePositioning 
        ? <Info>{formatMessage({id: "autoTrackingInactive", defaultMessage: "Automatisk lokalisering er ikke tilgjengelig når posisjonering er avskrudd."})}</Info>
        : hasGeofence ? <Info>{formatMessage({id: "autoTrackingInactiveGeofence", defaultMessage: "Automatisk lokalisering er på og har geofence"})}</Info>
        : processingAutoTracking ? <LoaderWrap><Loader/></LoaderWrap>
          : <ToggleWrap>
              <Toggle
                onChange={(value: boolean) => {
                  updateAutoTracking(value);
                  setFieldValue("autoTracking.value", value ? "true" : "false");
                  if(!value){
                    setFieldValue("powerSaving.value", "false");
                    updatePowerSaving(false);
                  }
                }}
                checked={values.autoTracking.value === "true"}
              />
            </ToggleWrap>}
      </PaddedCol>
    </RowWrapper>
  )
}))

const mapStateToProps = ({ settings: {tracking: { autoTracking, disablePositioning, processingAutoTracking, powerSaving }, geofence:{geofence}, device: {device: {deviId}}}}: AppState) => {
  return {
    autoTracking,
    disablePositioning,
    processingAutoTracking,
    deviId,
    powerSaving,
    geofence
  }
}

const mapDispatchToProps = {
  updateAutoTracking,
  updatePowerSaving
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoToggle);
